import React from "react";
import companyDetails from "../constants/company.json";
import bg from "../assets/bg.svg";

const LoginLayout = ({ image, altText, children }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 w-screen h-screen">
      <div className="flex items-end relative hidden lg:block">
        <img
          src={bg}
          alt={altText}
          className="absolute inset-0 h-screen w-full object-cover"
        />
        <img
          src={image}
          className="object-cover absolute h-screen w-full z-[-2]"
          alt={altText}
        />
        <div className="absolute flex flex-col justify-between px-6 items-center h-40 bottom-[3rem]">
          <p className="text-white text-6xl font-semibold">
            {companyDetails.name}
          </p>
          <p className="text-white text-center text-xl font-bold">
            {companyDetails.description}
          </p>
        </div>
      </div>
      <div className="relative h-screen">{children}</div>
    </div>
  );
};
export default LoginLayout;
